import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import InstallPrompt from './InstallPrompt';
import { useSettings } from '../context/SettingsContext';

import { Phone, MapPin } from 'lucide-react';

const Footer = () => {
    const { settings } = useSettings();

    const renderOpeningHours = () => {
        if (!settings.openingHours) return null;
        const days = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
        const formatDay = (d) => d.charAt(0).toUpperCase() + d.slice(1);

        return days.map(day => {
            const h = settings.openingHours[day];
            if (!h || !h.ouvert) return <span key={day} style={{ display: 'block', marginBottom: '3px' }}>{formatDay(day)} : Fermé</span>;

            // Format nice string representation
            const hoursStr = [h.matin, h.apresMidi].filter(Boolean).join(' - ') || "En continu";
            return <span key={day} style={{ display: 'block', marginBottom: '3px' }}>{formatDay(day)} : {hoursStr}</span>;
        });
    };

    return (
        <footer className="footer">
            <div className="container footer-container">
                <div className="footer-column">
                    <img src={settings.siteLogo || "/images/logo_real.jpg"} alt={`Logo ${settings.siteName}`} className="footer-logo" />
                    <p className="footer-text">
                        {settings.siteSlogan}
                    </p>
                    <div className="footer-contact-item">
                        <MapPin size={16} className="text-gold" style={{ marginRight: '10px' }} />
                        <span>{settings.address}</span>
                    </div>
                    <div className="footer-contact-item">
                        <Phone size={16} className="text-gold" style={{ marginRight: '10px' }} />
                        <span>{settings.phone}</span>
                    </div>
                </div>
                <div className="footer-column">
                    <h4 className="footer-heading">Horaires</h4>
                    <p className="footer-hours" style={{ fontSize: '0.95rem', lineHeight: '1.4' }}>
                        {renderOpeningHours()}
                    </p>
                </div>
                <div className="footer-column">
                    <h4 className="footer-heading">Liens</h4>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <Link to="/mentions-legales" className="footer-link">Mentions Légales</Link>
                        <Link to="/confidentialite" className="footer-link">Politique de confidentialité</Link>
                        <div style={{ marginTop: '10px' }}>
                            <InstallPrompt />
                        </div>
                    </div>
                    <p className="footer-copyright">
                        © {new Date().getFullYear()} {settings.siteName}.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
